import React, { useMemo } from 'react'
import PropTypes from 'prop-types'

import './Loader.scss'

const CLASS = 'insights-loader'

const maxDots = 26
const dotSize = 20
const dotSpace = 30

const Loader = props => {
  const dotCount = props.dotCount || maxDots

  const dots = useMemo(
    () => Array.from({ length: dotCount }, (_v, i) => <span key={i} className="dot"></span>),
    [dotCount]
  )

  const className = useMemo(() => `${CLASS}${props.className ? ` ${props.className}` : ''}`, [props.className])

  const containerStyle = useMemo(() => props.style || null, [props.style])

  const loaderStyle = useMemo(() => {
    return { left: `-${(((maxDots - dotCount) * (dotSize + dotSpace)) / 4 + dotSize / 2).toFixed()}px` }
  }, [dotCount])

  return (
    <div className={className} style={containerStyle}>
      <div className="loader" style={loaderStyle}>
        {dots}
      </div>
      {props.title ? (
        <div className="afd-panel">
          <div className="afd-panel-text">
            <div>Loading your</div>
            <div className="afd-panel-text-title">{props.title}</div>
            <div>Portal</div>
          </div>
        </div>
      ) : props.caption ? (
        <div className="afd-panel">
          <div className="afd-panel-caption">{props.caption}</div>
        </div>
      ) : null}
    </div>
  )
}

Loader.propTypes = {
  className: PropTypes.string,
  title: PropTypes.any,
  caption: PropTypes.any,
  style: PropTypes.object,
  dotCount: PropTypes.number
}

Loader.defaultProps = {
  dotCount: 26
}

export default Loader
